import api from "../api/index";
export const SAVE_CATEGORIES= 'SAVE_CATEGORIES';

export const categoriesData = categories => ({
    type: SAVE_CATEGORIES,
    payload: categories,
});

export const getCategories = () => {
    return dispatch => {
        return api.vehicle.categories().then(({data})=> {
            dispatch(categoriesData(
                data
            ))
        })
    }
}
export const SAVE_POLICY_TRANSPORT_STEP= 'SAVE_POLICY_TRANSPORT_STEP'

export const openPolicyPaymentDialog = policy => ({
    type: SAVE_POLICY_TRANSPORT_STEP,
    payload: policy,
});



// WEBPACK FOOTER //
// ./src/actions/categories.js